export enum SeminarState {
  CREATED = 'created',
  SCHEDULED = 'scheduled',
  ACTIVE = 'active',
  COMPLETED = 'completed',
  CANCELED = 'canceled',
}

export interface SupportDocument {
  label: string;
  link: string;
}

export interface SeminarInterface {
  id: string;
  title: string;
  description: string;
  supportDocuments: SupportDocument[];
  state: SeminarState;
  hostId: string;
  length: number;
  scheduledStart: string;
}
